import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { AuthService } from "@core/auth.service";
import { IonicModule } from "@ionic/angular";
@Component({
    selector: "app-password-text",
    templateUrl: "./password-text.page.html",
    styleUrls: ["./password-text.page.scss"],
    standalone: true,
    imports: [IonicModule, TranslatePipe],
})
export class PasswordTextPage implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<PasswordTextPage>,
    private authService: AuthService,
    public translate: TranslateService
  ) {
    this.authService?.selectedlanguage$?.subscribe(
      (l) => {
        if (l) {
          translate.use(l ? l : "en");
        }
      },
      (err) => {
        return err;
      }
    );
  }

  ngOnInit() {}

  backToLogin() {
    this.dialogRef.close();
  }
}
